<template>
    <span
        v-if="color"
        class="color-mark"
        :style="styles"></span>
</template>

<script>
export default {
    name: 'ColorMark',
    props: {
        color: {
            type: String,
            required: true,
        },
    },
    computed: {
        styles() {
            const { color } = this;
            const res = {};
            if (color) {
                res.backgroundColor = color;
            }
            return res;
        },
    },
};
</script>

<style lang="scss" scoped>
.color-mark {
    display: inline-block;
    width: 1em;
    height: 1em;
    line-height: 0;
    transform: translateY(2px);
    border-radius: 3px;
    margin-right: 2px;
}
</style>
